
export const METRICS = [
  { label: 'Scripts Created', value: '48', delta: '+12%' },
  { label: 'Active Pipelines', value: '7', delta: '+3' },
  { label: 'Avg Run Time', value: '2.4s', delta: '-15%' },
  { label: 'Success Rate', value: '94%', delta: '+2%' },
];

export const SC_SCRIPT_TYPES = ['DDL', 'DML', 'Both'];

export const SC_LANGUAGES = ['SQL', 'PostgreSQL', 'MySQL', 'Snowflake', 'Oracle'];
